import purchaseItem from '@/components/new-checkout/purchase-item';
import SelectPayment from '@/components/new-checkout/select-payment';
import { getCreditCards, finishPayment, getPaymentStatus } from '@/services/api/transactions.js';
import { setPurchaseActionLog } from '@/services'
import { currencyFilter } from '@/utils/filters';
import { mapActions, mapState } from 'vuex';

export default {
    components: { purchaseItem, SelectPayment },
    name: 'NewCheckout',
    data: () => ({
        isMobile: false,
        creditCards: [],
        purchaseData: [],
        loadingForm: false,
        loadingMainButton: false,
        showForm: false,
        form: {
            installment: 1,
            paymentMethodCode: 'credit_card',
            price: '',
            type: '',
            items: [],
            paymentProfile: ''
        },
        installments: [
            {
                name: 'À vista (1x sem juros)',
                value: 1
            },
            {
                name: '2x sem juros',
                value: 2
            },
            {
                name: '3x sem juros',
                value: 3
            }
        ],
        changeSelectedCard: true,
        showButton: false,
        qrCodePath: '',
        qrCodeLink: 'teste 2',
        showQrCode: false,
        statusPayment: false,
        counter: 30,
        timer: null,
        transactionId: '',
    }),
    async created() {
        await this.getCreditCardList();
        this.purchaseData.push(this.purchaseDataObject);
    },
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 768;
        });
        vue.isMobile = window.innerWidth <= 768;
    },
    methods: {
        ...mapActions('notification', ['showNotification']),
        ...mapActions('sweetalert2', ['showAlert']),
        ...mapActions('checkout', ['setPackageCoin']),
        ...mapActions('user', ['setSubscriptionHeader']),
        currencyFilter,
        removeItem(index) {
            this.goOutScreenLog();
            this.setPackageCoin({});
            this.purchaseData.splice(index, 1);
        },
        async makeForm() {
            const data = {};
            data.paymentMethodCode = this.form.paymentMethodCode,
            data.type = this.purchaseDataObject.type,
            data.paymentProfile = this.form.paymentProfile,
            data.price = this.totalPrice;
            data.items = await this.setItens();
            data.installments = this.form.installment;
            return data;
        },
        async finishPurchase() {
            try {
                this.loadingMainButton = true;
                const data = await this.makeForm();
                if (data.paymentMethodCode === 'pix') this.showQrCode = true
                const response = await finishPayment(data);
                this.transactionId = response.bill.id
                if (data.paymentMethodCode === 'bank_slip') {
                    const result = await this.$swal({
                        title: 'Boleto gerado e enviado para seu email com sucesso!',
                        icon: 'success',
                        allowOutsideClick: false,
                        confirmButtonText: 'Imprimir o Boleto Agora!'
                    });
                    if (result && result.isConfirmed) {
                        window.open(response.bill.charges[0].printUrl, '_blank');
                    }
                    this.$router.push({ name: 'CompetitionDashboard' });
                    this.setPackageCoin({});
                }
                if (data.paymentMethodCode === 'credit_card') {
                    const result = await this.$swal({
                        title: 'Seu pedido foi recebido! Estamos processando seu pagamento!',
                        icon: 'success',
                        allowOutsideClick: false
                    });
                    if (result && result.isConfirmed) {
                        this.setSubscriptionHeader();
                        this.$router.push({ name: 'CompetitionDashboard' });
                    }
                    this.setPackageCoin({});
                }
                if (data.paymentMethodCode === 'pix') {
                    this.qrCodePath = response.bill.charges[0].lastTransaction.gatewayResponseFields.qrcodePath
                    this.qrCodeLink = response.bill.charges[0].lastTransaction.gatewayResponseFields.qrcodeOriginalPath
                    this.showButton = false;
                    this.setCounter();
                }
            } catch (error) {
                this.loadingMainButton = false;
                console.error(error);
                this.showNotification({ text: error.response.data.errors[0].message, type: 'error' });
            } finally {
                this.loadingMainButton = false;
            }
        },
        async getCreditCardList() {
            try {
                this.loadingForm = true;
                const { paymentProfiles } = await getCreditCards();
                this.creditCards = paymentProfiles;
                if (!this.creditCards.length) {
                    this.showForm = true;
                } else {
                    this.showForm = false;
                }
            } catch (error) {
                this.loadingForm = false;
                console.error(error);
                this.showNotification({ text: error.status, type: 'error' });
            } finally {
                this.loadingForm = false;
            }
        },
        async getPaymentStatus(id) {
            try {
                const response = await getPaymentStatus(id);
                this.statusPayment = response
                if(this.statusPayment.paid) {
                    clearInterval(this.timer)
                    const result = await this.$swal({
                        title: 'Pagamento realizado com sucesso!',
                        icon: 'success',
                        allowOutsideClick: false
                    });
                    if (result && result.isConfirmed) {
                        this.$router.push({ name: 'CompetitionDashboard' });
                        this.setSubscriptionHeader();
                    }
                    this.setPackageCoin({});
                } else {
                    clearInterval(this.timer)
                    this.counter = 30
                    this.setCounter();
                }
            } catch (error) {
                console.error(error);
                this.showNotification({ text: error.status, type: 'error' });
            } finally {
                this.loadingForm = false;
            }
        },
        setCounter() {
            this.timer = setInterval(() => {
                this.counter -= 1
                if(this.counter === 0) {
                    this.counter = 0;
                    this.getPaymentStatus(this.transactionId)
                }
            }, 1000)
        },
        setSelectedCard(card) {
            this.form.paymentProfile = card;
            this.showButton = true;
        },
        setPaymentMethodCode(code) {
            this.form.paymentMethodCode = code;
            this.form.paymentProfile = '';
            this.changeSelectedCard = !this.changeSelectedCard;
            this.showButton = false;
        },
        setItens() {
            const itens = [];
            this.purchaseData.forEach(item => {
                const newItem = {
                    id: item.id,
                    amount: item.transactionValue
                };
                itens.push(newItem);
            });
            return itens;
        },
        async goOutScreenLog() {
            if(this.purchaseData.length) {
                await setPurchaseActionLog({
                    'balancePurchase' : this.purchaseData[0].id
                })
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        this.goOutScreenLog();
        next();
    },
    unmounted() {
        clearInterval(this.timer)
    },
    computed: {
        ...mapState('checkout', ['packageCoin']),
        purchaseDataObject() {
            return this.packageCoin;
        },
        totalPrice() {
            return this.purchaseData.map(item => item.transactionValue).reduce((prev, curr) => prev + curr, '');
        },
        isEmpty() {
            return Object.keys(this.purchaseDataObject).length > 0;
        },
        buttonSize() {
            return this.isMobile ? '' : 'extra-large';
        }
    }
};
